// extracted by mini-css-extract-plugin
export default {"rowItems":"Table_rowItems__0jkGK","rowItem":"Table_rowItem__8-isr","cellItem":"Table_cellItem__6Q6Pw","cell":"Table_cell__g3a6c"};